// extracted by mini-css-extract-plugin
module.exports = {"modal":"BoxPickupScheduleOrderModal_modal__kpA4r"};